export enum BidStatusType {
  None,
  SentToContractors,
  SentToTurnover,
  Accepted,
  Rejected,
}
